export default {
    phoneLines: [
        "0150",
        "0151",
        "0152",
        "0157",
        "0159",
        "0160",
        "0162",
        "0163",
        "0170",
        "0171",
        "0172",
        "0173",
        "0174",
        "0175",
        "0176",
        "0177",
        "0178",
        "0179",
        "015019",
        "01502",
        "01505",
        "01508",
        "01520",
        "01520",
        "01521",
        "01522",
        "01523",
        "01525",
        "01526",
        "01529",
        "01531",
        "01555",
        "01556",
        "015566",
        "01563",
        "01566",
        "01567",
        "01570",
        "01573",
        "01575",
        "01577",
        "01578",
        "01579",
        "01588",
        "01590",
    ],

    serviceProviders: [
        "1&1",
        "7,7 Cent",
        "AirBerlin",
        "Alice",
        "allMobil",
        "Alphatel",
        "AOL",
        "Atu",
        "Ay Yildiz",
        "BASE",
        "BILD",
        "Blau",
        "Blauworld powered by Ortel",
        "Blauworld",
        "callmobile",
        "Cellway",
        "chixx",
        "congstar",
        "Conrad",
        "debitel light",
        "debitel",
        "DeutschlandSIM",
        "discoPLUS",
        "discoTEL",
        "DOKOM21 Dortmund",
        "Drillisch",
        "E-Plus",
        "easyTel",
        "eBay",
        "Edeka Mobil",
        "encoLine Gera",
        "EnoCom Karlsruhe",
        "eteleon",
        "EWE (vormals EWE TEL)",
        "Express",
        "FCB Mobil",
        "fiotel",
        "Fonic",
        "foto@phone",
        "Freenet",
        "freenetmobile",
        "Freephone",
        "Frischfunk",
        "FYVE",
        "Galeria mobil",
        "Gruner & Jahr",
        "GTCom",
        "Hansenet",
        "HeLi NET Hamm",
        "hellomobil",
        "HFO Telecom Hof",
        "HL komm Leipzig",
        "htp Hannover",
        "ja! mobil",
        "Jamba!",
        "JKR Bad Kreuznach",
        "KEVAG Telekom Koblenz",
        "KielNET/Versatel Kiel",
        "klarmobil",
        "komro Rosenheim",
        "Lebara",
        "Lidl",
        "Lokalisten Fon",
        "Lycamobile",
        "M-net Mobil",
        "maXXim",
        "McSIM",
        "MEDIONmobile",
        "Mobika powered by Ortel",
        "mobil09",
        "mobilcom",
        "MoWoTel",
        "My Mobile Internet",
        "NetCologne Dienste",
        "NetCologne Mobil",
        "NetCom BW Ellwangen",
        "Netcom Kassel",
        "NettoKom",
        "nt-v go",
        "o2 Germany",
        "Ortel Mobil",
        "osnatel",
        "otelo",
        "PENNY mobil",
        "Phonex.de",
        "Plus-Kom",
        "PremiumSIM",
        "primacom (primaholding) Berlin",
        "Regio Plus Dresden",
        "Rossmann",
        "RTL Surfstick",
        "RTLmobil",
        "Sat. 1",
        "SC-Fan-Tarife",
        "Schlecker Mobil (smobil)",
        "Schlecker Prepaid",
        "Schwarzfunk/Weissfunk",
        "Scott (BASE Prepaid)",
        "sdt.net Aalen",
        "sim.de",
        "SimDiscount",
        "Simfinity",
        "simply",
        "simquadrat",
        "SIMVoice",
        "Simyo",
        "sipgate",
        "Sky",
        "smartmobil",
        "SmileMobile",
        "Sparhandy",
        "Sport. 1",
        "Stadtwerke Schwedt",
        "STAR Communications",
        "SurfSpot",
        "swb (vormals nordcom)",
        "SWU Telenet Ulm",
        "talkline",
        "Tchibo mobil",
        "Telco",
        "Tele2",
        "Telekom",
        "The Phonehouse",
        "Tismi BV",
        "TKS easyMobile",
        "TNG Stadtnetz Kiel",
        "TOGGO",
        "Truphone",
        "TUI-Surfstick",
        "Turkcell",
        "Unitymedia (BW)",
        "Unitymedia",
        "VICTORVOX",
        "VIVA",
        "Vodafone",
        "Vodafone CallYa",
        "Voiceworks",
        "Volkswagen TeleCom",
        "voxenergie (primaholding) Berlin",
        "Vybemobile",
        "wilhelm.tel Norderstedt",
        "willy.tel Hamburg",
        "winSIM",
        "WKW Mobil",
        "WKW-Surfstick",
        "WN-Mobilfunk",
        "WOBCOM Wolfsburg",
        "Woodman",
        "Yahoo! Internet Stick",
        "Youni",
        "yourfone",
    ],
};



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/app/modules/checkout-form/number-porting/config.ts